module.exports = __webpack_public_path__ + "img/tracking-settings@2x.dd4f3d2b.png";